<template>
  <div>
    <div class="max-w-xl p-6 mx-auto">
      <div class="flex items-start p-4 mb-4 text-sm border rounded bg-accent bg-opacity-10 text-accent border-accent" v-if="options.time_help_text">
        <fa :icon="['fas', 'info-circle']" class="mt-px mr-3 text-lg opacity-75" />
        <div>
          {{ options.time_help_text }}
        </div>
      </div>

      <div class="grid h-full grid-cols-4 gap-1">
        <label 
          v-for="slot in timetable"
          :key="slot.label"
          class="flex items-center justify-center py-2 text-center bg-white rounded" 
          :class="{ 
            'bg-accent text-white hover:bg-accent': form.time === slot.label,
            'opacity-50 text-gray-400 cursor-not-allowed': slot.disabled,
            'hover:bg-gray-50 cursor-pointer': !slot.disabled
          }">
            <input class="hidden" type="radio" :value="slot.label === 'None' ? null : slot.label" :name="slot.label" :id="slot.label" v-model="form.time" :disabled="slot.disabled"> 
            <div class="font-medium">
              {{ slot.label }}
            </div>
        </label>
      </div>
      <validations :errors="errors" field="time" />
    </div>

    <BookBottomBar>
      <template slot="back">
        <button class="w-full btn btn-outline" @click="$parent.back()">
          <fa :icon="['far', 'chevron-left']" class="mr-2 text-sm" /> Back
        </button>
      </template>
      <template slot="next">
        <button class="w-full btn btn-accent" :class="{ 'opacity-75 cursor-not-allowed': options.time_requirement === 'required' && !form.time }" @click="next()">
          Next <fa :icon="['far', 'chevron-right']" class="ml-2 text-sm" />
        </button>
      </template>
    </BookBottomBar>
    
  </div>
</template>

<script>
import { isWithinInterval, min, max, addMinutes, format } from 'date-fns'
import { mapFields } from 'vuex-map-fields'
import BookBottomBar from './BookBottomBar'

export default {
  name: 'BookTime',

  components: {
    BookBottomBar
  },

  computed: {
    ...mapFields('booking', ['form', 'options']),

    dayOfWeek () {
      const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
      const selectedDay = this.form.date.getDay()
      return weekdays[selectedDay]
    },

    applicableSchedules () {
      return this.options.schedules.filter(schedule => schedule[this.dayOfWeek] === true)
    },

    earliestStartTime () {
      let allStartTimes = this.options.schedules.map((schedule) => {
        const hms = schedule.start_time.split(':')
        return new Date(2020, 1, 1, hms[0], hms[1], hms[2])
      })
      return min(allStartTimes)
    },

    latestEndTime () {
      let allEndTimes = this.options.schedules.map((schedule) => {
        const hms = schedule.end_time.split(':')
        return new Date(2020, 1, 1, hms[0], hms[1], hms[2])
      })
      return max(allEndTimes)
    },

    timetable () {
      const times = []
      const interval = ({ start: this.earliestStartTime, end: this.latestEndTime })
      
      let slot = { 
        time: this.earliestStartTime,
        label: format(this.earliestStartTime, 'HH:mm'),
        disabled: false 
      }

      while (isWithinInterval(slot.time, interval)) {
        times.push(slot)
        slot = { 
          time: addMinutes(slot.time, this.timeslot_interval), 
          label: format(addMinutes(slot.time, this.timeslot_interval), 'HH:mm'),
          disabled: true 
        }
      }

      const scheduleStart = (schedule) => {
        const hms = schedule.start_time.split(':')
        return new Date(2020, 1, 1, hms[0], hms[1], hms[2])
      }

      const scheduleEnd = (schedule) => {
        const hms = schedule.end_time.split(':')
        return new Date(2020, 1, 1, hms[0], hms[1], hms[2])
      }

      const scheduleInterval = (schedule) => {
        return { start: scheduleStart(schedule), end: scheduleEnd(schedule) }
      }

      for (let time of times) {
        for (let schedule of this.options.schedules) {
          if (isWithinInterval(time.time, scheduleInterval(schedule))) {
            time.disabled = false
          }
        }
      }

      // TODO Q32021: Allow users to define if "None" is an available time
      times.push({ time: null, label: 'None', disabled: true })

      return times
    }
  },

  data () {
    return {
      errors: [],
      timeslot_interval: 30
    }
  },

  methods: {
    next () {
      if (this.options.time_requirement === 'required' && !this.form.time) {
        this.$toasted.error('Please select a time to proceed.')
        this.errors = [
          { 
            field: 'time', 
            rule: 'required', 
            message: 'Please select a time to proceed.' 
          }
        ]
      } else {
        this.$parent.next()
      }
    }
  }
}
</script>